const state = {};

const getters = {};

const actions = {
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/nlt-mailing-list-management`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/nlt-mailing-list-management/${params}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/nlt-mailing-list-management`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/nlt-mailing-list-management/${data.id}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/nlt-mailing-list-management`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}